import { Button, Input, InputGroup, InputGroupText, Modal, ModalBody, ModalHeader } from "reactstrap";
import { CreateNewMessageTitle } from "../../../../../Constants/Constants";
import { useAppDispatch, useAppSelector } from "../../../../../ReduxToolkit/Hooks";
import { setNewModal } from "../../../../../ReduxToolkit/Reducers/Messenger/Messenger";
import AllCall from "../CallTab/AllCall";

const CallModal = () => {
  const dispatch = useAppDispatch();
  const { newModal } = useAppSelector((state) => state.messenger);
  return (
    <Modal isOpen={newModal[1]} toggle={() => dispatch(setNewModal(1))} className="fade show add-popup msg-chat-modal" centered>
      <ModalHeader>
        {CreateNewMessageTitle}
        <Button className="close" onClick={() => dispatch(setNewModal(1))}>
          <span>×</span>
        </Button>
      </ModalHeader>
      <ModalBody className="p-0 pt-2">
        <div className="chat-msg-search px-3">
          <InputGroup>
            <Input type="text" placeholder="Search" />
            <div className="input-group-append">
              <InputGroupText>@</InputGroupText>
            </div>
          </InputGroup>
        </div>
        <AllCall startValue={0} endValue={6} />
      </ModalBody>
    </Modal>
  );
};

export default CallModal;
